import type { LanguageCode } from '../types';

const SAME_LANGUAGES: Partial<Record<LanguageCode, string[]>> = {
  'en-US': ['en', 'en-US']
};

export function checkSameLanguages(language: string | LanguageCode) {
  const result = Object.entries(SAME_LANGUAGES).find(([, values]) =>
    values.find((value) => value.toLowerCase() === language.toLowerCase())
  );

  if (result) {
    return result[0];
  }

  const splitLanguage = language.split('-');

  if (
    splitLanguage.length > 1 &&
    splitLanguage[0] === splitLanguage[1].toLowerCase()
  ) {
    return splitLanguage[0];
  }

  return language;
}
